module.exports = __webpack_public_path__ + "img/96.696a439d.jpg";